import * as React from "react";
import { cn } from "../../utils/cn";

type CustomProps = {
  image: {
    src: string;
    alt?: string;
  };
  heading: string;
  text: string;
};

export interface CardProps extends React.HTMLProps<HTMLDivElement>, CustomProps {}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, children, heading, text, image, ...props }, ref) => {
    return (
      <div
        className={cn("flex flex-col rounded-md bg-background-secondary", className)}
        ref={ref}
        {...props}
      >
        <div className="mb-2">
          <img className="h-48 w-full object-cover" src={image.src} alt={image.alt} />
        </div>
        <div className="flex flex-col justify-between p-4">
          <h3 className="text-2xl font-semibold text-text-primary">{heading}</h3>
          <p className="md:text-md">{text}</p>
          {children}
        </div>
      </div>
    );
  },
);

Card.displayName = "Card";

export { Card };
